import type { InsuranceScenarioResultColumn } from '@/general/src/insuranceScenario/webapp.js'

export const personalKaskoInsuranceScenarioResultColumns: InsuranceScenarioResultColumn[] = [
  {
    heading: 'Адрес страницы',
    width: 370,
    key: 'url',
    body: (sd) => sd.result.url,
  },
  {
    heading: 'Дата',
    width: 200,
    key: 'date',
    body: (sd) => sd.result.date,
  },
]
